import { formatIntField, formatPhoneNumber } from "./backoffice/utils";
import AutoNumeric from "autonumeric";
import { format as formatRut } from "rut.js";
import "select2";
import "select2/dist/css/select2.css";

export function lightOrDark(color) {
  // Check the format of the color, HEX or RGB?
  var r = "";
  var g = "";
  var b = "";
  if (color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(
      /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/
    );

    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"));

    r = color >> 16;
    g = (color >> 8) & 255;
    b = color & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {
    return "light";
  } else {
    return "dark";
  }
}
export function pickTextColorBasedOnBgColorAdvanced(
  bgColor,
  lightColor,
  darkColor
) {
  var color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
  var r = parseInt(color.substring(0, 2), 16); // hexToR
  var g = parseInt(color.substring(2, 4), 16); // hexToG
  var b = parseInt(color.substring(4, 6), 16); // hexToB
  var uicolors = [r / 255, g / 255, b / 255];
  var c = uicolors.map((col) => {
    if (col <= 0.03928) {
      return col / 12.92;
    }
    return Math.pow((col + 0.055) / 1.055, 2.4);
  });
  var L = 0.2126 * c[0] + 0.7152 * c[1] + 0.0722 * c[2];
  return L > 0.55 ? darkColor : lightColor;
}

export const updateDynamicColorElements = function (targets) {
  Array.from(targets).forEach((target, element) => {
    var color = target.getAttribute("data-color");
    var actual_font_color = target.getAttribute("data-font-color") || color;
    if (color) {
      var font_color = pickTextColorBasedOnBgColorAdvanced(
        color,
        actual_font_color,
        "#000000"
      );
      const note = target;
      note.style.color = font_color;
      if (font_color == "#000000" && color != "#000000") {
        var alternative_color = target.getAttribute("data-alternative");
        target.style.color = alternative_color || font_color;
        target.style.borderColor = alternative_color || font_color;
      }
    }
  });
};
export var Fn = {
  // Valida el rut con su cadena completa "XXXXXXXX-X"
  formatRut: function (rut) {
    var pointless = rut.split(".").join("");
    var dashless = pointless.split("-").join("");
    return (
      dashless.substring(0, dashless.length - 1) +
      "-" +
      dashless.substring(dashless.length - 1, dashless.length)
    );
  },
  validaRut: function (rutField) {
    //if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
    var rutCompleto = rutField.value;
    if (rutField.value === "-") {
      rutField.value = "";
      rutCompleto = "";
    }
    var tmp = Fn.formatRut(rutCompleto);
    var tmp2 = tmp.split("-");
    var digv = tmp2[1];
    var rut = tmp2[0];
    if (digv == "K") digv = "k";
    return Fn.dv(rut) == digv;
  },
  dv: function (T) {
    var M = 0,
      S = 1;
    for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
    return S ? S - 1 : "k";
  },
};

const DEFAULT_DOCUMENT_TYPE = {
  label: 'Documento',
  numeric_only: false,
  checksum: false,
  min_length: null,
  max_length: null,
  placeholder: '',
};

export const getDocumentTypeConfig = (countryCode) => {
  const key = (countryCode || '').toString().toLowerCase();
  return (window.DOCUMENT_TYPES_CONFIG && window.DOCUMENT_TYPES_CONFIG[key]) || DEFAULT_DOCUMENT_TYPE;
};

// Mirrors Donator#sanitizes_tax_id: strips everything but digits for numeric-only document
// types (PE/CO/etc), or just dots/dashes for Chile-style RUTs (keeps the trailing check digit).
export const sanitizeTaxId = (value, countryCode) => {
  if (!value) return value;
  const config = getDocumentTypeConfig(countryCode);
  return config.numeric_only
    ? value.toString().replace(/\D/g, '')
    : value.toString().split('.').join('').split('-').join('').trim();
};

// Mirrors TaxIdValidator (app/services/tax_id_validator.rb) so the same rules apply client-side
// before submit. The length bounds are expressed over the sanitized value (what the server
// stores), so a displayed RUT like "12.345.678-5" must be sanitized before measuring it.
export const validateTaxId = (value, countryCode) => {
  if (!value) return true;
  const config = getDocumentTypeConfig(countryCode);
  const v = (sanitizeTaxId(value, countryCode) || '').toString();
  if (!v) return true;

  if (config.min_length && v.length < config.min_length) return false;
  if (config.max_length && v.length > config.max_length) return false;
  if (config.numeric_only && !/^\d+$/.test(v)) return false;
  if (config.checksum) return Fn.validaRut({ value: v });

  return true;
};

export const formatTaxIdInput = (rawValue, countryCode) => {
  const config = getDocumentTypeConfig(countryCode);
  const value = sanitizeTaxId(rawValue, countryCode) || '';
  return config.checksum ? formatRut(value) : value;
};

$(document).on('focus', '.tax_id_input', function () {
  if (this.maxLength > 0) return;
  const config = getDocumentTypeConfig(window.country_code);
  if (!config.max_length) return;
  const formattingOverhead = config.checksum ? 3 : 0;
  this.maxLength = config.max_length + formattingOverhead;
});

const isElementVisible = (el) => {
  if (!el) return false;
  if (el.type === "hidden") return false;
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
};

const getScrollTarget = (field) => {
  if (
    field.type === "hidden" ||
    field.id === "phone-number" ||
    field.id === "donator_phone_number"
  ) {
    const phoneInput = document.getElementById("phone_number_hidden_input");
    if (phoneInput) return phoneInput;

    if (
      field.id === "donator_donation_transactions_attributes_0_amount" ||
      field.id === "dt_amount"
    ) {
      const amountForm = document.getElementById("amount_form");
      const visibleAmountInput = amountForm?.querySelector(
        "input:not([type=hidden])"
      );
      if (visibleAmountInput && isElementVisible(visibleAmountInput)) {
        return visibleAmountInput;
      }
      const qtyDesktop = document.getElementById("product-quantity-desktop");
      const qtyMobile = document.getElementById("product-quantity-mobile");
      if (qtyDesktop && isElementVisible(qtyDesktop)) return qtyDesktop;
      if (qtyMobile && isElementVisible(qtyMobile)) return qtyMobile;
      if (amountForm) return amountForm;
    }
  }

  const manyChoices = field.closest(".input-field--many-choices");
  if (manyChoices) {
    const firstCheckbox = manyChoices.querySelector('input[type="checkbox"]');
    if (firstCheckbox) return firstCheckbox;
  }

  return field;
};

const isFieldInvalid = (field) => {
  return field.classList.contains("is-invalid") || !field.checkValidity();
};

export const scrollToElement = (el) => {
  const target = el instanceof Element ? el : el?.[0];
  if (!target) return;

  target.scrollIntoView({ behavior: "smooth", block: "center" });
  if (
    typeof target.focus === "function" &&
    target.type !== "hidden" &&
    !target.disabled
  ) {
    try {
      target.focus({ preventScroll: true });
    } catch (_) {
      target.focus();
    }
  }
};

export const scrollToFirstInvalidField = (form) => {
  if (!form) return false;

  const fields = form.querySelectorAll("input, select, textarea");
  for (const field of fields) {
    if (!isFieldInvalid(field)) continue;

    const target = getScrollTarget(field);
    if (!target) continue;

    if (isElementVisible(target) || target !== field) {
      scrollToElement(target);
      return true;
    }
  }

  return false;
};

export const validateFormData = (form) => {
  return scrollToFirstInvalidField(form);
};

export const basicValidation = () => {
  "use strict";
  window.addEventListener(
    "load",
    function () {
      var forms = document.getElementsByClassName("basic-needs-validation");
      var validation = Array.prototype.filter.call(forms, function (form) {
        form.addEventListener(
          "submit",
          function (event) {
            formatPhoneNumber();
            formatIntField();
            if (form.checkValidity() === false) {
              event.preventDefault();
              event.stopPropagation();
            }
            form.classList.add("was-validated");
          },
          false
        );
      });
    },
    false
  );
};

export const validatePhoneNumbers = (form) => {
  let phoneInputField = document.getElementsByClassName("phone-number-input");
  let isValid = true;
  if (phoneInputField) {
    for (var i = 0; i < phoneInputField.length; i++) {
      var iti = window.intlTelInputGlobals.getInstance(phoneInputField[i]);
      if (iti.isValidNumber()) {
        phoneInputField[i].classList.remove("is-invalid");
      } else {
        phoneInputField[i].classList.add("is-invalid");
        isValid = false;
      }
      isValid
        ? form.addClass("was-validated")
        : form.removeClass("was-validated");
      return isValid;
    }
  }
};

export const updateImgPreview = (event) => {
  const file = event.target.files[0];
  const element = $(event.currentTarget);
  if (file) {
    const reader = new FileReader();

    reader.onload = function (e) {
      if (element.parent().siblings().find("#img-preview img").length != 0) {
        element
          .parent()
          .siblings()
          .find("#img-preview img")
          .attr("src", e.target.result);
      } else {
        const img = $("<img />", {
          src: e.target.result,
        });
        element.parent().siblings().find("#img-preview").append(img);
      }
      element.parent().siblings().find("#img-preview")[0].style.background =
        "#FFFFFF";
    };
    reader.readAsDataURL(file); // Convert image to base64 string
  }
};

export const validateFormControl = (element) => {
  let format_validation = true;
  if (
    element.closest(".form-group").id == "amount_form" ||
    element.closest(".form-group").id == "amount_form_card"
  ) {
    return;
  }
  if (element.type == "email") {
    // check email format with regex
    const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!reg.test(element.value)) {
      format_validation = false;
    }
  }
  var validation = element.checkValidity();
  if (!validation || !format_validation) {
    element.classList.add("is-invalid");
    element.classList.remove("is-valid");
  } else {
    element.classList.add("is-valid");
    element.classList.remove("is-invalid");
  }
};

export const getCurrencyFormatOptions = (currency) => {
  const key = (currency || '').toString().toLowerCase();
  const config = (window.CURRENCIES_CONFIG && window.CURRENCIES_CONFIG[key]) || {};
  return {
    digitGroupSeparator: config.thousands_separator || '.',
    decimalCharacter: config.decimal_separator || ',',
    decimalPlaces: config.precision !== undefined ? config.precision : 2,
  };
};

export const getCurrencyLanguageCode = (currency) => {
  const key = (currency || '').toString().toLowerCase();
  const config = (window.CURRENCIES_CONFIG && window.CURRENCIES_CONFIG[key]) || {};
  return config.language_code || 'es-CL';
};

// Converts a currency-formatted string (whatever thousands/decimal separators that currency
// uses) into a plain JS number with '.' as the decimal point — the format the backend expects.
export const parseAmountString = (rawValue, currency) => {
  const { digitGroupSeparator, decimalCharacter } = getCurrencyFormatOptions(currency);
  let raw = (rawValue || '').toString();
  if (digitGroupSeparator) {
    raw = raw.split(digitGroupSeparator).join('');
  }
  if (decimalCharacter && decimalCharacter !== '.') {
    raw = raw.replace(decimalCharacter, '.');
  }
  return parseFloat(raw);
};

export const getNumericAmount = (element, currency) => {
  const el = typeof element === 'string'
    ? document.querySelector(element)
    : (element && element.jquery ? element[0] : element);
  if (!el) return NaN;

  const autoNumericInstance = AutoNumeric.getAutoNumericElement(el);
  if (autoNumericInstance) {
    return parseFloat(autoNumericInstance.getNumericString());
  }

  return parseAmountString(el.value, currency);
};

// Backoffice-only: formatting rules for ".currency-amount-field" inputs (causes/greeting cards
// admin forms). Falls back to a plain integer (no decimals) instead of the PEN/UF-style
// getCurrencyFormatOptions default when the resolved value isn't a real configured currency —
// e.g. the cause "goal" field can hold a subscriber count ("subscriptions") instead of a currency.
const currencyAmountFieldFormatOptions = (currency) => {
  const key = (currency || '').toString().toLowerCase();
  if (window.CURRENCIES_CONFIG && window.CURRENCIES_CONFIG[key]) {
    return getCurrencyFormatOptions(key);
  }
  return { digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: 0 };
};

// Resolves the currency that applies to a ".currency-amount-field" element: either its static
// data-currency, or (when data-currency-source is set) the live value of the nearest matching
// <select>, scoped to the field's closest repeated-row container so multiple instances on the
// same page (e.g. one row per price card) don't read each other's selector.
const resolveCurrencyAmountFieldCurrency = (el) => {
  const selector = el.dataset.currencySource;
  if (!selector) return el.dataset.currency;
  const scope = el.closest('.nested-fields') || el.closest('form') || document;
  const sourceEl = scope.querySelector(selector);
  return (sourceEl && sourceEl.value) || el.dataset.currency;
};

// Single delegated listener (bound once, ever) that keeps every ".currency-amount-field[data-
// currency-source]" in sync with its <select>. Delegation means it doesn't matter whether the
// field existed at page load or was inserted afterwards (e.g. a cocoon nested-fields row) — there
// is nothing to (re-)bind per element, so there's no risk of a row's listener silently not being
// attached. Mirrors the existing delegated ".price-currency-selector" change handler in cause.js.
let currencyAmountFieldChangeDelegated = false;
const bindCurrencyAmountFieldChangeDelegation = () => {
  if (currencyAmountFieldChangeDelegated) return;
  currencyAmountFieldChangeDelegated = true;
  document.addEventListener('change', (event) => {
    const scope = event.target.closest('.nested-fields') || event.target.closest('form') || document;
    scope.querySelectorAll('.currency-amount-field[data-currency-source]').forEach((el) => {
      if (scope.querySelector(el.dataset.currencySource) !== event.target) return;
      const an = AutoNumeric.getAutoNumericElement(el);
      if (an) an.update(currencyAmountFieldFormatOptions(resolveCurrencyAmountFieldCurrency(el)));
    });
  });
};

// Wires up (or re-syncs) AutoNumeric on every ".currency-amount-field" under `root`, formatting
// each one per its resolved currency. Safe to call repeatedly (e.g. after a nested-fields row is
// added) — already-initialized fields are left untouched.
export const initCurrencyAmountFields = (root = document) => {
  bindCurrencyAmountFieldChangeDelegation();
  const scope = root && root.jquery ? root[0] : (root || document);
  scope.querySelectorAll('.currency-amount-field').forEach((el) => {
    if (!AutoNumeric.getAutoNumericElement(el)) {
      new AutoNumeric(el, currencyAmountFieldFormatOptions(resolveCurrencyAmountFieldCurrency(el)));
    }
  });
};

// Call right before submitting a form containing ".currency-amount-field" inputs: normalizes
// every one of them to a plain "." decimal string (whatever it was displaying) and detaches its
// AutoNumeric instance, so the raw value that reaches the controller is always backend-safe.
export const unformatCurrencyAmountFields = (root = document) => {
  const scope = root && root.jquery ? root[0] : (root || document);
  scope.querySelectorAll('.currency-amount-field').forEach((el) => {
    const value = getNumericAmount(el, resolveCurrencyAmountFieldCurrency(el));
    const an = AutoNumeric.getAutoNumericElement(el);
    if (an) an.remove();
    el.value = Number.isNaN(value) ? '' : value;
  });
};

export const setupAutoNumeric = (currency, autoNumericInstance, elementId, currencySymbol = '') => {
  const { digitGroupSeparator, decimalCharacter, decimalPlaces } = getCurrencyFormatOptions(currency);
  const config = {
    digitGroupSeparator,
    decimalCharacter,
    decimalPlaces,
    currencySymbol: currencySymbol,
  };

  if (autoNumericInstance) {
    autoNumericInstance.update(config);
  } else {
    autoNumericInstance = new AutoNumeric(elementId, config);
  }

  return autoNumericInstance;
};

export function initVolunteerSupervisorSelect2($root) {
  const $scope = $root && $root.length ? $root : $(document);
  $scope.find(".volunteer-select, .supervisor-select").each(function () {
    const $select = $(this);
    if ($select.hasClass("select2-hidden-accessible")) {
      $select.select2("destroy");
    }
    const placeholder =
      $select.data("placeholder") ||
      ($select.hasClass("supervisor-select") ? "Sin supervisor" : "Buscar voluntario...");
    const $modal = $select.closest(".modal");
    $select.select2({
      placeholder,
      allowClear: true,
      width: "100%",
      dropdownParent: $modal.length ? $modal : $(document.body),
      class: "form-control",
    });
  });
}

export const loadModalContent = (url, containerSelector, loadingClass, onComplete) => {
  const container = $(containerSelector).first();
  container.html(`<div class='loading ${loadingClass} m-auto'></div>`);
  $.ajax({
    url: url,
    dataType: "json"
  })
    .done(function (data) {
      if (data.response) {
        container.html(data.response);
        if (typeof onComplete === "function") {
          onComplete(container);
        }
      } else {
        container.html("<p class='text-muted'>No hay datos para mostrar.</p>");
      }
    })
    .fail(function () {
      container.html("<p class='text-danger'>Error cargando datos.</p>");
    });
}

const PROPOSED_SECTION = ".account-proposed-subcategory-section";
const PROPOSED_INFO_ALERT = "[data-proposed-subcategory-info-alert]";

const isProposedSubcategoryPending = (form) =>
  form.find(PROPOSED_SECTION).first().attr("data-proposed-subcategory-pending") === "true";

const hideProposedSubcategory = (form) => {
  const section = form.find(PROPOSED_SECTION).first();
  if (!section.length) return;

  form.find(PROPOSED_INFO_ALERT).addClass("d-none");
  const input = section.find(".account-proposed-subcategory-input");
  section.addClass("d-none");
  input.prop({ disabled: true, required: false });
  input.val("");
  input.removeClass("is-invalid is-valid");
};

const showProposedSubcategory = (form) => {
  const section = form.find(PROPOSED_SECTION).first();
  if (!section.length) return;

  section.removeClass("d-none");
  section.find(".account-proposed-subcategory-input").prop({ disabled: false, required: true });
  form.find(PROPOSED_INFO_ALERT).removeClass("d-none");
};

const syncProposedSubcategoryToSelect = (select) => {
  const form = select.closest("form");
  if (isProposedSubcategoryPending(form)) return;

  const kind = select.find("option:selected").attr("data-kind");
  if (kind === "other") {
    showProposedSubcategory(form);
  } else {
    hideProposedSubcategory(form);
  }
};

export const updateSubcategorySelectOptions = () => {
  const subcategorySelect = $(document).find("#account_account_subcategory_ids");
  if (subcategorySelect.length > 0 && subcategorySelect[0].value === '') {
    subcategorySelect.prop("disabled", true);
  }
  $(document).on("change", "#account_account_category_id", function () {
    const form = $(this).closest("form");
    if (isProposedSubcategoryPending(form)) return;

    const accountSubcategoryIds = form.find("#account_account_subcategory_ids");

    hideProposedSubcategory(form);

    accountSubcategoryIds.empty();
    accountSubcategoryIds.append(`<option value="">Cargando subcategorías...</option>`);
    accountSubcategoryIds.prop("disabled", true);
    const categoryId = $(this).val();
    fetch(`${window.location.origin}/account_subcategories?category_id=${categoryId}`, {
      headers: {
        "Accept": "application/json"
      }
    })
      .then(response => response.json())
      .then(data => {
        const subcategories = data.subcategories;
        accountSubcategoryIds.empty();
        if (subcategories.length > 0) {
          subcategories.forEach(subcategory => {
            accountSubcategoryIds.append(
              $("<option></option>")
                .attr("value", subcategory.id)
                .attr("data-kind", subcategory.kind)
                .text(subcategory.name)
            );
          });
          accountSubcategoryIds.prop("disabled", false);
          accountSubcategoryIds.prop("required", true);
        } else {
          accountSubcategoryIds.append(`<option value="">No hay subcategorías disponibles</option>`);
          accountSubcategoryIds.prop("required", false);
          accountSubcategoryIds.removeAttr("required");
          accountSubcategoryIds.prop("disabled", true);
        }
        syncProposedSubcategoryToSelect(accountSubcategoryIds);
      })
      .catch(error => {
        console.error("Error fetching subcategories:", error);
        syncProposedSubcategoryToSelect(accountSubcategoryIds);
      });
  });

  $(document).on("change", "#account_account_subcategory_ids", function () {
    syncProposedSubcategoryToSelect($(this));
  });

  $("#account_account_subcategory_ids").each(function () {
    syncProposedSubcategoryToSelect($(this));
  });
};

export function copy(copyId) {
  navigator.clipboard.writeText($("" + copyId).text()).then(() => {
    $(".alert").fadeIn(500, function () {
      $(".alert").fadeOut();
    });
  });
}

export const applyVolunteerFieldFilters = (kindValue, fields) => {
  fields.forEach((wrapper) => {
    const conditions = JSON.parse(wrapper.dataset.showConditions || "null");
    let visible = true;
    if (conditions) {
      if (kindValue === "digital")
        visible = conditions.active_digital_volunteers;
      else if (kindValue === "street")
        visible = conditions.active_street_volunteers;
      else if (kindValue === "mixed")
        visible =
          conditions.active_digital_volunteers ||
          conditions.active_street_volunteers;
    }
    wrapper.style.display = visible ? "" : "none";
    wrapper.querySelectorAll("input, select, textarea").forEach((el) => {
      el.required = visible && el.dataset.required === "true";
    });
  });
};
